// extracted by mini-css-extract-plugin
export default {"section":"NotFound_section__WHVpa","inner":"NotFound_inner__mysMD","code":"NotFound_code__6F7kT","title":"NotFound_title__n52PY","description":"NotFound_description__NtSGT"};